import React, { useEffect, useMemo, useRef, useState } from 'react'
import CreatePaymentMethod from '../../components/payment/CreatePaymentMethod'
import PaymentMethodList from '../../components/payment/PaymentMethodList'
import { useFetch,usePost,useCurrent,useDelete,usePut } from '../../hooks';
import { MwSpinner,ConfirmDelete } from '../../components/ui';
import UpdatePaymentMethod from '../../components/payment/UpdatePaymentMethod';

const PaymentMethod = () => {
    const {currentTenantId,currentCompanyId,currentBranchId,userId,currentLangList,currentLangId} =  useCurrent()
    const canFetchContext = Boolean(currentTenantId && currentCompanyId && currentBranchId);
    const financeBaseUrl = useMemo(() => {
        if (process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL) {
            return process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL.replace(/\/+$/, '');
        }
        if (process.env.REACT_APP_INV_API_SALES_SERVER_BASE_URL) {
            return process.env.REACT_APP_INV_API_SALES_SERVER_BASE_URL.replace(/\/sales\/?$/, '/finance').replace(/\/+$/, '');
        }
        return `${(process.env.REACT_APP_API_URL || '').replace(/\/+$/, '')}/finance`;
    }, []);
    const {data:paymentMethods,loading,refreshHandler} = useFetch(`${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/payment-methods/${currentTenantId}/${currentCompanyId}/${currentBranchId}`)
    const { data: treasuriesData } = useFetch(
        canFetchContext ? `${financeBaseUrl}/treasuries/${currentTenantId}/${currentCompanyId}/${currentBranchId}` : null
    );
    const {data:dataCreate,loading:loadingCreate,postData:postCreate} = usePost();
    const {data:dataUpdate,loading:loadingUpdate,putData:putData} = usePut();
    const [itemSelected,setItemSelected] = useState({});
    const {deleteItem,data:dataDelete,loading:loadingDelete} = useDelete();
    const [isConfirmDelete,setIsConfirmDelete] = useState(false);
    const [mode,setMode] = useState('Adding');
    const refreshRef = useRef(refreshHandler);


    useEffect(() => {
        console.log(paymentMethods)
    },[paymentMethods]);


    useEffect(() => {
        refreshRef.current = refreshHandler;
    },[refreshHandler]);

    useEffect(() => {
        if(dataCreate || dataUpdate || dataDelete){
            refreshRef.current();
            setMode('Adding');
        }
    },[dataCreate, dataUpdate, dataDelete]);

    const confirmDeleteHandler = (item) =>{
        setItemSelected(item)
        setIsConfirmDelete(true)
        console.log(isConfirmDelete)
    }

    const deleteHandler = () =>{
        const id = itemSelected?.id;
        console.log(itemSelected);
        const url = `${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/payment-methods/delete/${id}`;
        deleteItem(url);
    }

    const editHandler = (item) => {
        setItemSelected(item)
        setMode('Editing')
    }

    useEffect(() => {
        if(!loadingDelete && isConfirmDelete){
            setIsConfirmDelete(false);
        }
    },[loadingDelete]);

    return (
        <div className=''>
            <ConfirmDelete 
                onShow={isConfirmDelete} 
                setOnShow={setIsConfirmDelete}  
                title={`Deleting...`}
                msg={`Are you sure you want to delete`}
                onDeleteHandler={deleteHandler}
                loading ={loadingDelete}
                />
            { mode === 'Adding' ? <CreatePaymentMethod
                currentLangList = {currentLangList} 
                currentTenantId = {currentTenantId}
                currentCompanyId = {currentCompanyId}
                currentBranchId = {currentBranchId}
                currentLangId = {currentLangId}
                userId = {userId}
                data = {dataCreate}
                loading = {loadingCreate}
                postData = {postCreate}
            /> : <UpdatePaymentMethod
                    currentLangList = {currentLangList} 
                    currentTenantId = {currentTenantId}
                    currentCompanyId = {currentCompanyId}
                    currentBranchId = {currentBranchId}
                    currentLangId = {currentLangId}
                    userId = {userId}
                    currentItem = {itemSelected}
                    data = {dataUpdate}
                    loading = {loadingUpdate}
                    putData = {putData}
                />
            }
            <div className='h-8'></div>
            { !!paymentMethods ? <PaymentMethodList 
                                confirmDeleteHandler ={confirmDeleteHandler} 
                                editHandler = {editHandler}
                                data={paymentMethods} 
                                loading={loading} 
                                currentLangId={currentLangId}
                                treasuriesData={treasuriesData}
                                /> : <div className='h-40'> <MwSpinner hightScreen={false}/>  </div>}
        </div>
    )
}

export default PaymentMethod
